import styled from 'styled-components/macro';

type FlexWrapperProps = {
  width?: string;
  justify?:
    | 'space-around'
    | 'space-between'
    | 'space-evenly'
    | 'start'
    | 'center'
    | 'end'
    | 'flex-start'
    | 'flex-end';
  align?:
    | 'start'
    | 'center'
    | 'end'
    | 'baseline'
    | 'flex-start'
    | 'flex-end'
    | 'stretch';
  wrap?: 'wrap' | 'nowrap' | 'unset';
  direction?: 'column' | 'row';
};
export default styled.div<FlexWrapperProps>`
  display: flex;
  width: ${(p) => p.width ?? '100%'};
  justify-content: ${(p) => p.justify ?? 'space-between'};
  flex-direction: ${(p) => p.direction ?? 'row'};
  align-items: ${(p) => p.align ?? 'center'};
  flex-wrap: ${(p) => p.wrap ?? 'unset'};
`;
